module.exports = __webpack_public_path__ + "img/icn_emoji.5d202083.svg";